import { render } from "./ViewChildLink.vue?vue&type=template&id=1c1ece37"
import script from "./ViewChildLink.vue?vue&type=script&lang=js"
export * from "./ViewChildLink.vue?vue&type=script&lang=js"

import "./ViewChildLink.vue?vue&type=style&index=0&id=1c1ece37&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__